module.exports = __webpack_public_path__ + "static/media/Lexington-commons.979ae380.pdf";